<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.patients', 1) }}
                    </h3>
                </div>
            </div>

            <div class="" :class="[ mobileView ? 'pt-3': 'card-body']">
                <b-form  @reset="onReset" v-if="show">
                    <div class="" :class="[ mobileView ? '': 'container']">

                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="institution-group"
                                        :label="$t('message.institutionConsultation')"
                                        label-for="institution"
                                >
                                    <select id="institution" v-model="$v.form.institution.$model"
                                            @change="clearErrorField('etablissement_id')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                            multiple
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mUserInstitutions" :key="item.id" :value="item.id">
                                            {{ item.nom }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.institution.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('etablissement_id')" style="color:red">
                                    {{getErrorsField('etablissement_id')}}
                                    </span>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="lastName-group"
                                        :label="$t('message.lastName')"
                                        label-for="nom"
                                        description=""
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.nom.$model"
                                            :state="$v.form.nom.$dirty ? !(errorshasField('nom') || $v.form.nom.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('nom')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.nom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('nom')">
                                        {{ getErrorsField('nom') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="lastName-group"
                                        :label="$t('message.firstName')"
                                        label-for="nom"
                                        description=""
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.prenom.$model"
                                            :state="$v.form.prenom.$dirty ? !(errorshasField('prenom') || $v.form.prenom.$error) : null"
                                            type="text"
                                            placeholder=""
                                            @focus="clearErrorField('prenom')"
                                    ></b-form-input>

                                    <!--                                    <b-form-invalid-feedback v-if="!$v.form.prenom.required">-->
                                    <!--                                        {{ $t('message.requiredField') }}-->
                                    <!--                                    </b-form-invalid-feedback>-->

                                    <b-form-invalid-feedback v-if="errorshasField('prenom')">
                                        {{ getErrorsField('prenom') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                        </b-row>

                        <b-row>
                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="telephone-group"
                                        :label="$t('message.phoneNumber')"
                                        label-for="telephone"
                                >
                                    <!-- <b-form-input
                                            id="telephone"
                                            v-model="$v.form.telephone.$model"
                                            :state="$v.form.telephone.$dirty ? !(errorshasField('telephone') || $v.form.telephone.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('telephone')"
                                    ></b-form-input> -->
                                    <vue-tel-input  class="form-control"
                                            id="telephone"
                                            v-model="$v.form.telephone.$model"
                                            required
                                            placeholder=""
                                            :state="$v.form.telephone.$dirty ? !(errorshasField('telephone') || $v.form.telephone.$error) : null"
                                            @focus="clearErrorField('telephone')"
                                            >
                                    </vue-tel-input>

                                    <b-form-invalid-feedback v-if="!$v.form.telephone.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
<!--                                    <b-form-invalid-feedback v-if="!$v.form.telephone.integer">-->
<!--                                        {{ $t('message.integer', { n: 9 }) }}-->
<!--                                    </b-form-invalid-feedback>-->
                                    <b-form-invalid-feedback v-if="!$v.form.telephone.minLength">
                                        {{ $t('message.minCharacters', { n: 9 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.telephone.numericValidator">
                                        {{ $t('message.integer', { n: 9 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-else-if="errorshasField('telephone')">
                                        {{ getErrorsField('telephone') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="1">
                                <div>
                                    <label class="form__label" for="hasDesc">Email</label>
                                    <div class="toggle">
                                        <input id="hasDesc" type="checkbox" v-model="hasPatientEmail"/>
                                        <label for="hasDesc">
                                            <div class="toggle__switch"></div>
                                        </label>
                                    </div>
                                </div>
                            </b-col>
                            <b-col sm="3">
                                <div v-if="hasPatientEmail" :class="{ 'form-group--error': $v.form.email.$error}">
                                    <span  class="obligatoire">*</span>
                                    <b-form-group
                                            id="email-group"
                                            :label="$t('message.email')"
                                            label-for="email"
                                    >
                                        <b-form-input
                                                id="email"
                                                v-model="$v.form.email.$model"
                                                :state="$v.form.email.$dirty ? !(errorshasField('email') || $v.form.email.$error) : null"
                                                type="email"
                                                required
                                                placeholder=""
                                                @focus="clearErrorField('email')"
                                        ></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.email.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="!$v.form.email.email">
                                            {{ $t('message.emailNotValid') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('email')">
                                            {{ getErrorsField('email') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="sexe-group"
                                        :label="$t('message.gender')"
                                        label-for="sexe">
                                    <b-form-select
                                            id="sexe"
                                            v-model="$v.form.sexe.$model"
                                            :state="$v.form.sexe.$dirty ? !(errorshasField('sexe') || $v.form.sexe.$error) : null"
                                            :options="sexes"
                                            required
                                            @focus="clearErrorField('sexe')"
                                    ></b-form-select>

                                    <b-form-invalid-feedback v-if="!$v.form.sexe.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('sexe')">
                                        {{ getErrorsField('sexe') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <i class="fas fa-question float-right" id="popover-target-1"></i>
                                <b-popover target="popover-target-1" triggers="hover" placement="top">
                                    <template v-slot:title>{{$t('message.unknownDate')}}</template>
                                    {{$t('message.unknownDateText')}}
                                </b-popover>
                                <b-form-group
                                        id="dob-group"
                                        :label="$t('message.dob')"
                                        label-for="dob">
                                    <b-form-input
                                            id="dob"
                                            v-model="$v.form.date_de_naissance.$model"
                                            :state="$v.form.date_de_naissance.$dirty ? !(errorshasField('date_de_naissance') || $v.form.date_de_naissance.$error) : null"
                                            type="date"
                                            placeholder=""
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="errorshasField('date_de_naissance')">
                                        {{ getErrorsField('date_de_naissance') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.date_de_naissance.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>


                                </b-form-group>

                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="nationalite-group"
                                        :label="$t('message.nationality')"
                                        label-for="nationalite"
                                >
                                    <b-form-input
                                            id="nationalite"
                                            v-model="$v.form.nationalite.$model"
                                            :state="$v.form.nationalite.$dirty ? !(errorshasField('nationalite') || $v.form.nationalite.$error) : null"
                                            @focus="clearErrorField('nationalite')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('nationalite')">
                                        {{ getErrorsField('nationalite') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.nationalite.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="singleAddPatient-group"
                                        :label="$t('message.select')+' '+$tc('message.countries', 1)"
                                        label-for="singleAddPatient">
                                    <!-- Options -->
                                    <select id="singleAddPatient"  v-model="form.pays" required
                                            class="form-control is-invalid retirerBordure"
                                    >
                                        <option v-for="item in mCountries" :value="item.value" :key="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>

                                    <b-form-invalid-feedback v-if="errorshasField('pays')">
                                        {{ getErrorsField('pays') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.pays.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>


                                </b-form-group>

                            </b-col>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="ville-group"
                                        :label="$tc('message.cities', 1)"
                                        label-for="ville"
                                >
                                    <b-form-input
                                            id="ville"
                                            v-model="$v.form.ville.$model"
                                            :state="$v.form.ville.$dirty ? !(errorshasField('ville') || $v.form.ville.$error) : null"
                                            @focus="clearErrorField('ville')"
                                            required
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('ville')">
                                        {{ getErrorsField('ville') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.ville.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="street-group"
                                        :label="$t('message.street')"
                                        label-for="street"
                                >
                                    <b-form-input
                                            id="street"
                                            v-model="$v.form.quartier.$model"
                                            :state="$v.form.quartier.$dirty ? !(errorshasField('quartier') || $v.form.quartier.$error) : null"
                                            @focus="clearErrorField('quartier')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('quartier')">
                                        {{ getErrorsField('quartier') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="zipCode-group"
                                        :label="$t('message.zipCode')"
                                        label-for="zipCode"
                                >
                                    <b-form-input
                                            id="zipCode"
                                            v-model="$v.form.code_postal.$model"
                                            :state="$v.form.code_postal.$dirty ? !(errorshasField('code_postal') || $v.form.code_postal.$error) : null"
                                            @focus="clearErrorField('code_postal')"
                                            type="number"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('code_postal')">
                                        {{ getErrorsField('code_postal') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="address-group"
                                        :label="$t('message.address')"
                                        label-for="address"
                                >
                                    <b-form-input
                                            id="address"
                                            v-model="$v.form.adresse.$model"
                                            :state="$v.form.adresse.$dirty ? !(errorshasField('adresse') || $v.form.adresse.$error) : null"
                                            @focus="clearErrorField('adresse')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('adresse')">
                                        {{ getErrorsField('adresse') }}
                                    </b-form-invalid-feedback>

                                    <!--                                    <b-form-invalid-feedback v-else-if="!$v.form.adresse.required">-->
                                    <!--                                        {{ $t('message.requiredField') }}-->
                                    <!--                                    </b-form-invalid-feedback>-->

                                </b-form-group>

                            </b-col>
                        </b-row>
                        <!-- <b-row>
                            <b-col sm="6">
                                <b-form-group
                                        id="question-group"
                                        :label="$t('message.select')+' '+$t('message.secretQuestion')"
                                        label-for="question">
                                    <select id="question"  v-model="$v.form.question_id.$model"
                                            class="form-control is-invalid retirerBordure"
                                    >
                                        <option v-for="item in mQuestions" :value="item.value" :key="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>

                                    <b-form-invalid-feedback v-if="errorshasField('question_id')">
                                        {{ getErrorsField('question_id') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>
                            </b-col>
                            <b-col sm="6">

                                <b-form-group
                                        id="lastName-group"
                                        :label="$t('message.answer')"
                                        label-for="reponse"
                                        description=""
                                >
                                    <b-form-input
                                            id="reponse"
                                            v-model="$v.form.reponse.$model"
                                            :state="$v.form.reponse.$dirty ? !(errorshasField('reponse') || $v.form.reponse.$error) : null"
                                            type="text"
                                            placeholder=""
                                            @focus="clearErrorField('reponse')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('reponse')">
                                        {{ getErrorsField('reponse') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>
                        </b-row> -->
                        <b-row>
                            <b-col sm="6">
                                <div>
                                    <label class="form__label" for="hasDesc">{{$t('message.isMedPatner')}}</label>
                                    <div class="toggle">
                                        <input id="hasDesc2" type="checkbox" v-model="form.isMed"/>
                                        <label for="hasDesc2">
                                            <div class="toggle__switch"></div>
                                        </label>
                                    </div>
                                </div>
                            </b-col>
                            <b-col sm="12" v-if="form.isMed">
                                <b-row class="mb-2">
                                    <b-col sm="6">
                                        <span>Souscripteur: <strong>{{item.text}}</strong></span>
                                    </b-col>
                                    <b-col sm="6">
                                        <button  type="button" class=" btn btn-danger btn-sm" @click="clearSouscripteur">Supprimer</button>
                                    </b-col>
                                </b-row>
                                <div class="vgt-global-search vgt-clearfix">

                                    <div class="vgt-global-search__input vgt-pull-left"><span class="input__icon">
                                        <div class="magnifying-glass">

                                        </div>
                                    </span>
                                        <input type="text" placeholder="Search user" class="vgt-input vgt-pull-left" v-model="searchTerm">
                                    </div>
                                    <div class="vgt-global-search__actions vgt-pull-right">

                                    </div>
                                </div>
                                <vue-good-table
                                        id="operation"
                                        :columns="mSubscribersColumns"
                                        :rows="mSubscribersFilter"
                                        :search-options="{
                                        enabled:true,
                                        externalQuery: searchTerm
                                        }"
                                        :pagination-options="paginationOptions"
                                        @on-row-click="onSubscriberClick"
                                />

                                <span v-if="errorshasField('souscripteur_id')" style="color: red">
                                    {{ getErrorsField('souscripteur_id') }}
                                </span>
                                <br>
                            </b-col>
                        </b-row>

                    </div>

                    <b-container>
                        <b-row class="justify-content-center" v-if="can">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.save') }}
                            </b-button>

                            <!--                                <b-button type="reset" variant="danger">-->
                            <!--                                    {{ $t('message.reset') }}-->
                            <!--                                </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import VueTelInput from 'vue-tel-input';
    import 'vue-tel-input/dist/vue-tel-input.css';
    import { required, email, minLength,integer,maxLength } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';
    import moment from "moment";
    const numericValidator = string => (/^[0-9]+$/gi).test(string);

    Vue.use(VueTelInput, {
        dropdownOptions: {
            showSearchBox: true,
            showDialCodeInSelection: true
        },
        inputOptions: {
            required: true,
            autofocus: true,
            showDialCode: true
        },
        invalidMsg:'Saisissez un numéro de téléphone correct',
        preferredCountries: ['cm', 'be', 'fr']
    });

    export default {
        name: "AddPatient",
        component: {
            VueTelInput,
        },
        computed: {
            ...mapGetters(["countries", "subscribers", "errors",'hasAdminRole',
                'hasGestionnaireRole','hasPraticienRole','hasMedecinControleRole','hasAssistante',
                'hasSouscripteurRole',
                "userInstitutions",
                "questions",'hasAssistante'
            ]),

            userIsMed:function(){
                return (JSON.parse(localStorage.getItem('user')))['isMedicasure'];
            },

            mUserInstitutions: function() {
                let iArray = [];

                _.forEach(_.orderBy(this.userInstitutions,['created_at'],['desc']), function(institution) {
                    let i = {};

                    i.nom = institution.name;
                    i.description = (!_.isNull(institution.description)? institution.description.length > 20 : false) ? institution.description.substr(0, 20) + '...' : institution.description;
                    i.date = moment(institution.created_at).format('DD-MM-YYYY');
                    i.id = institution.id;
                    i.slug = institution.slug;

                    iArray.push(i);
                });

                return iArray;
            },


            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasSouscripteurRole || this.hasAssistante;
            },

            mCountries: function() {
                let cArray = [];

                _.forOwn(this.countries, function(value, key) {
                    cArray.push({ text: value.name, value: value.name });
                });

                return cArray;
            },

            mQuestions: function() {
                let qArray = [];

                _.forOwn(this.questions, function(value, key) {
                    qArray.push({ text: value.intitule, value: value.id });
                });

                return qArray;
            },

            mSubscribers: function() {
                let sArray = [];

                _.forOwn(this.subscribers, function(value, key) {
                    if (!_.isNull(value.user)){
                        let prenom  = value.user.prenom ? value.user.prenom : "";
                        prenom =  prenom.toLowerCase();
                        let fullName = (value.user.nom).toUpperCase()+ " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        sArray.push({ text: fullName, value: value.user.id });
                    }
                });

                return sArray;
            },
        },

        data() {
            return {
                item:{text:'Selectionner un souscripteur ci-dessous',value:0},
                searchTerm : '',
                mobileView: true,
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
                form: {
                    isMed: false,
                    quartier:'',
                    code_postal:'',
                    nom: '',
                    prenom: '',
                    adresse: '',
                    // souscripteur: null,
                    telephone: '',
                    email: '',
                    sexe: '',
                    date_de_naissance: '',
                    nationalite: '',
                    ville: '',
                    pays: '',
                    institution:[],
                    /* reponse:'',
                    question_id:null, */
                    role: this.$route.params.role != null ? this.$route.params.role : localStorage.getItem('role')

                },
                hasPatientEmail: false,
                sexes: [
                    { value: 'F', text: this.$i18n.t('message.female') },
                    { value: 'M', text: this.$i18n.t('message.male') }
                ],
                mSubscribersFilter:[],
                show: true,

                mSubscribersColumns: [
                    {
                        field: 'text',
                        label: this.$i18n.t('message.name'),
                    },
                ],
            }
        },
        watch:{
            hasPatientEmail:function(oldValue,newValue){
                if(newValue == false){
                    this.form.email = "";
                }
            },

            searchTerm:function (newValue, oldValue) {
                if (!this.hasPatientRole){
                    if (newValue.trim().length ==0){
                        this.mSubscribersFilter = [];
                    }else{
                        this.mSubscribersFilter = this.mSubscribers;
                    }
                }else{
                    this.mSubscribersFilter =this.mSubscribers;
                }
            }


        },

        methods: {
            clearSouscripteur(){
                this.item = {};
            },
            handleView() {
            this.mobileView = window.innerWidth < 991;
            },

            onSubscriberClick(params){
                // this.$router.push({ name: 'patient', params: { patient: params.row.value } });
                this.item = {};
                this.item = {text:params.row.text,value:params.row.value};
                this.searchTerm = '';
            },

            itemSelected:function(item){
            },
            itemChange:function(item){
                console.log(item );
            },

            getUserInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUserInstitutions', { args : args });
            },

            getQuestionsList() {
                let args = {
                };

                this.$store.dispatch('getQuestions', { args : args });
            },

            getCountries: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getCountries', { args, errorMessages });
            },

            getSubscribers: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getSubscribers', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();
                //Définition du souscripteur du patient
                let sous = '0';
                if (this.hasAssistante){
                    sous = this.item.value;
                }

                if(!this.$v.$invalid ) {
                    let args = {
                        nom: this.form.nom,
                        prenom: this.form.prenom,
                        // souscripteur_id: sous,
                        email: this.form.email,
                        telephone: this.form.telephone,
                        sexe: this.form.sexe,
                        date_de_naissance: this.form.date_de_naissance,
                        nationalite: this.form.nationalite,
                        ville: this.form.ville,
                        adresse: this.form.adresse,
                        pays: this.form.pays,
                        quartier:this.form.quartier,
                        code_postal:this.form.code_postal,
                        etablissement_id:this.form.institution,
                        /* question_id:this.form.question_id,
                        reponse:this.form.reponse, */
                        isMedicasure: this.form.isMed ? '1' :'0',
                        role: this.form.role
                    };
                    console.log(args);
                    if (this.hasAssistante && this.form.isMed == true){
                        args = {...args, souscripteur_id: sous}
                    }

                    let successMessage = this.$i18n.t('message.patientCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };
                    this.$store.dispatch('createPatient', { args, errorMessages, successMessage })
                    .then(() => {
                        // Scroll to the top of the page
                        document.body.scrollTop = 0; // For Safari
                        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                    });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.nom = '';
                this.form.prenom = '';
                this.form.adresse = '';
                this.form.souscripteur = '';
                this.form.email = '';
                this.form.telephone = '';
                this.form.sexe = '';
                this.form.date_de_naissance = '';
                this.form.nationalite = '';
                this.form.ville = '';
                this.form.pays = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations() {
            if(this.hasPatientEmail){
                return {
                    form: {
                        isMed: {

                        },

                        nom: {
                            required
                        },

                        institution: {
                            required
                        },
                        prenom: {
                            //
                        },
                        // souscripteur: {
                        //     required
                        // },
                        telephone: {
                            required,
                            minLength: minLength(6),
                        },
                        email:{
                            required,
                            email
                        },

                        /* reponse: {
                            minLength: minLength(3)
                        },

                        question_id:{
                            integer
                        }, */

                        sexe: {
                            required
                        },
                        date_de_naissance: {
                            required
                        },
                        nationalite: {
                            // required
                        },
                        ville: {
                            required
                        },
                        pays: {
                            required
                        },
                        adresse: {
                            // required
                        },
                        quartier:{

                        },
                        code_postal:{

                        }
                    }
                }
            }else{
                return {
                    form: {
                        isMed: {

                        },

                        /* reponse: {
                            minLength: minLength(3)
                        },

                        question_id:{
                            integer
                        }, */

                        quartier:{

                        },
                        institution: {
                            required
                        },
                        code_postal:{

                        },
                        nom: {
                            required
                        },
                        prenom: {
                            //
                        },
                        // souscripteur: {
                        //     required
                        // },
                        telephone: {
                            required,
                        },
                        email:{
                            //
                        },

                        sexe: {
                            required
                        },
                        date_de_naissance: {
                            required
                        },
                        nationalite: {
                            //
                        },
                        ville: {
                            required
                        },
                        pays: {
                            required
                        },
                        adresse: {
                            // required
                        }
                    }
                }
            }

        },
        created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
        },
        mounted() {
            // Retrieve list of countries
            this.getCountries();

            // Retrieve list of subscribers
            this.getSubscribers();

            // Retrieve list of question
            this.getQuestionsList();

            new SlimSelect({
                select: '#singleAddPatient',
                placeholder: 'Select country'
            }) ;

            /* new SlimSelect({
                select: '#question',
                placeholder: 'Select secret question'
            }) ; */

            // new SlimSelect({
            //     select: '#souscripteur',
            //     placeholder: 'Select subscriber'
            // });

            // Fetch institution list
            this.getUserInstitutions();

            new SlimSelect({
                select: '#institution',
                placeholder: 'Select institution',
                limit:3
            });
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>